export default __webpack_public_path__ + "static/media/first.da5e73d4.png";